import {
  buildGeolocationGetRequest,
  useFetchApiAndTransform
} from "../useFetchApi";
import { Language } from "src/utils/localization/languages/types";
import { useDateOverride } from "src/utils/date/useDateOverride";
import {
  CruisePriceAndOffersV2Response,
  CruisePriceAndOffersV2QueryParams
} from "@silversea-ssc/dotcom-api-types/CruisePriceAndOffersV2";
import { useQuerySearch } from "src/utils/useQueryParams";

export type { CruisePriceAndOffersV2Response };

const useCruisePrice = (
  cruiseCode: string | undefined,
  language: Language
): CruisePriceAndOffersV2Response | undefined => {
  const dateOverride = useDateOverride();
  const querySearch = useQuerySearch();

  const request = cruiseCode
    ? buildGeolocationGetRequest<CruisePriceAndOffersV2QueryParams>(
        `v2/cruisePriceAndOffers/${cruiseCode}`,
        {
          date: dateOverride ? dateOverride.toISOString() : undefined
        },
        querySearch,
        language
      )
    : undefined;

  return useFetchApiAndTransform<
    CruisePriceAndOffersV2Response,
    CruisePriceAndOffersV2Response
  >(request, toMitigatedCruisePrice, ["cruise-prices", cruiseCode]).data;
};

const toMitigatedCruisePrice = (
  response: CruisePriceAndOffersV2Response
): CruisePriceAndOffersV2Response => {
  return response;
};

export default useCruisePrice;
